module.exports = __webpack_public_path__ + "static/media/incrowd2.56560255.gif";